export default __webpack_public_path__ + "static/media/secure-icon.f0a47481.svg";